import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react/dist/iconify.js';
import { ConfigContext } from '../context/GlobalContext';
import { SET_USER } from '../context/actions';
import { AddUser, EditUser } from '../data';
import Country from "../Utils/countries.json";
import Currancy from "../Utils/currency.json";
import Select from 'react-select';
import { getImage } from '../Utils/image_helper';
import AddPaymentDataInFirebase from '../data/Firebase/Payment/AddPaymentDataInFirebase';

const UserDetails = () => {
    const { state, dispatch } = useContext(ConfigContext);
    const navigate = useNavigate();
    const [field, setField] = useState(false);

    const [name, setname] = useState(state?.SET_USER?.name || '');
    const [referredBy, setreferredBy] = useState(state?.SET_USER?.referredBy || '');


    const [userPhone, setUserPhone] = useState(state?.SET_USER?.contact);
    const [userEmail, setUserEmail] = useState(state?.SET_USER?.email);


    const [currency, setCurrency] = useState(state?.SET_USER?.currency || state?.CURRENCYCODE);
    const [displayField, setdisplayField] = useState([]);

    const [selectedItem, setSelectedItem] = useState(null);
    const Email = state?.USERID ? state?.SET_USER?.email : "";
    const contact = state?.USERID ? state?.SET_USER?.contact : "";
    const [filteredCountries, setFilteredCountries] = useState(Currancy.CountryCurrencyResponse);
    const [currencySearch, setCurrencySearch] = useState("");

    const TaxType = () => {
        let taxType = "TAX";
        const VAT_CURRENCIES = ["EUR", "CZK", "DKK", "HUF", "PLN", "RON", "SEK", "GBP"];
        const GST_CURRENCIES = ["INR", "AUD"];
        const ABN_CURRENCIES = [];
        const SST_CURRENCIES = ["MYR"];
        const CAD_CURRENCIES = ["CAD"];
        if (VAT_CURRENCIES.includes(state?.CURRENCYCODE)) taxType = "VAT";
        else if (GST_CURRENCIES.includes(state?.CURRENCYCODE)) taxType = "GST";
        else if (ABN_CURRENCIES.includes(state?.CURRENCYCODE)) taxType = "ABN";
        else if (SST_CURRENCIES.includes(state?.CURRENCYCODE)) taxType = "SST";
        else if (CAD_CURRENCIES.includes(state?.CURRENCYCODE)) taxType = "GST/HST";

        dispatch({ type: 'TAXTYPE', payload: taxType });
    };

    useEffect(() => {
        TaxType();
    }, [state?.CURRENCYCODE]);

    useEffect(() => {
        const storedCurrencyCode = state?.SET_USER?.currency ? state?.SET_USER?.currency : state?.CURRENCYCODE;
        const matchedCurrency = Currancy.CountryCurrencyResponse.find(
            (c) => c.currencyCode === storedCurrencyCode
        );
        if (matchedCurrency) {
            setSelectedItem(matchedCurrency);
        }
        setFilteredCountries(Currancy.CountryCurrencyResponse);

        if (
            (state?.SET_USER?.social_id.includes('+'))
        ) {
            setField(true);
        } else {
            setField(false)
        }
    }, [state?.SET_USER]);



    const handleItemClick = (result) => {

        setSelectedItem(result);
        dispatch({ type: 'SYMBOL', payload: result.currencytSymbol });
        dispatch({ type: 'CURRENCYCODE', payload: result.currencyCode });
        dispatch({ type: 'CURRENCYNAME', payload: result.name });
        setCurrency(result.currencyCode);
        const country = Country.CurrencyResponse.find(c => c.isoAlpha2 === result.countryCode);
        if (country) {
            dispatch({ type: 'FLAG', payload: country.flag });
        }
    };

    const handleSave = async () => {
        const userData = {
            ...state.SET_USER,
            name,
            referredBy: referredBy || state?.SET_USER?.referredBy || null,
            currency: currency,
            ...(field
                ? { email: userEmail || state.SET_USER.email }
                : { contact: userPhone || state.SET_USER.contact }
            )
        };

        dispatch({ type: SET_USER, payload: userData });

        try {
            const userId = userData?.userId || null;

            await EditUser(state, dispatch, userId, userData);

            // ✅ Only call if user enters a NEW referral code (not previously saved)
            const wasReferralPreviouslyEmpty = !state?.SET_USER?.referredBy;
            const isReferralNowFilled = referredBy && referredBy.trim() !== "";

            // if (wasReferralPreviouslyEmpty && isReferralNowFilled) {
            //     await AddPaymentDataInFirebase(state, dispatch, state?.SET_USER?.referredBy);
            // }

            navigate(-1);
        } catch (error) {
            console.error("Error saving user:", error);
        }
    };


    const handleCancel = () => {
        setname(state?.SET_USER?.name || '');
        setUserPhone(state?.SET_USER?.contact);
        setUserEmail(state?.SET_USER?.email);

        navigate(-1);
    };


    const currencyOptions = filteredCountries.map(row => {
        const country = Country.CurrencyResponse.find(c => c.isoAlpha2 === row.countryCode);
        return {
            value: row.currencyCode,
            label: (
                <div className="d-flex align-items-center gap-2">
                    <img
                        src={
                            country?.flag
                                ? `data:image/png;base64,${country.flag}`
                                : getImage("euro_flag")
                        }
                        alt="flag"
                        width="25"
                        height="15"
                    />

                    <span>{row.name} ({row.currencyCode} - {row.currencytSymbol})</span>
                </div>
            ),
            raw: row,
        };
    });


    const selectedCurrencyOption = currencyOptions.find(
        (opt) => opt.raw.name === selectedItem?.name
    );

    const [filteredCurrencyOptions, setFilteredCurrencyOptions] = useState(currencyOptions);

    const handleCurrencySearch = (e) => {
        const value = e.target.value;
        setCurrencySearch(value);

        const trimmed = value.trim().toLowerCase();

        if (trimmed === "") {
            setFilteredCurrencyOptions(currencyOptions);
        } else {
            const filtered = currencyOptions.filter((opt) => {
                const label = String(opt.label || "").toLowerCase();
                const value = String(opt.value || "").toLowerCase();
                const country = String(opt.raw?.name || "").toLowerCase();

                return (
                    label.includes(trimmed) ||
                    value.includes(trimmed) ||
                    country.includes(trimmed)
                );
            });

            setFilteredCurrencyOptions(filtered);
        }
    };


    return (
        <div className="row">
            <div className="col-12">
                <div className="card border-0 shadow rounded-4 p-5">
                    <div className="d-flex align-items-center gap-2">
                        <button onClick={() => { navigate(-1) }}>
                            <i className="fa fa-arrow-left" style={{ fontSize: 18 }}></i>
                        </button>
                        <p className='fw-semibold mb-0' style={{ fontSize: 20 }}>User Details</p>
                    </div>

                    <div className="d-flex flex-column align-items-center mb-4">
                        {state?.USERID && (
                            <button
                                className="w-100-px h-100-px rounded-circle d-flex justify-content-center align-items-center"
                                type="button"
                                style={{ backgroundColor: "var(--brand)", color: "white", fontSize: "xxx-large" }}
                                onClick={() => navigate("/user_details")}
                            >
                                {name?.charAt(0)?.toUpperCase() ||
                                    Email?.charAt(0)?.toUpperCase() ||
                                    contact?.charAt(0)?.toUpperCase()}
                            </button>
                        )}
                        <label className="form-label">
                            {field ? state.SET_USER?.contact : state.SET_USER?.email}
                        </label>
                    </div>

                    <form className="mt-3">
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={name}
                                    onChange={(e) => setname(e.target.value)}
                                    placeholder="Your name"
                                />
                            </div>

                            <div className="col-md-6 mb-3">
                                <label className="form-label">
                                    {field ? 'Email' : 'Mobile Number'}
                                </label>
                                <input
                                    type={field ? 'email' : 'text'}
                                    className="form-control"
                                    value={field ? userEmail : userPhone}
                                    onChange={(e) =>
                                        field
                                            ? setUserEmail(e.target.value)
                                            : setUserPhone(e.target.value)
                                    }


                                    placeholder={
                                        field ? 'Enter your email' : 'Enter your phone number'
                                    }
                                />
                            </div>

                            <div className="col-6 col-md-6 mb-3">
                                <label className="form-label">Select Country</label>
                                <div className="dropdown">
                                    <button
                                        className="btn btn-outline-primary-600 dropdown-toggle w-100 d-flex justify-content-between align-items-center px-16 py-10 rounded"
                                        type="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        <span>{selectedCurrencyOption?.label || "Select Currency"}</span>
                                        <i className="bi bi-chevron-down"></i> {/* or use your preferred icon */}
                                    </button>
                                    <ul
                                        className="dropdown-menu w-100 mt-1 shadow-sm border-0 rounded-3 text-center hide-scrollbar"
                                        style={{ padding: 0 }}
                                    >
                                        {/* 🔍 Sticky Search */}
                                        <li className="py-2 sticky-top z-2">
                                            <input
                                                type="text"
                                                className="form-control countrybackground"
                                                placeholder="Search country..."
                                                value={currencySearch}
                                                onChange={handleCurrencySearch}
                                            />
                                        </li>

                                        {/* ✅ Scrollable container inside a <li> */}
                                        <li style={{ maxHeight: "250px", overflowY: "auto" }} className="hide-scrollbar">
                                            <ul className="list-unstyled mb-0">
                                                {filteredCurrencyOptions.length > 0 ? (
                                                    filteredCurrencyOptions.map((option) => (
                                                        <li key={option.id}>
                                                            <a
                                                                href="#"
                                                                className={`dropdown-item d-flex align-items-center gap-2 px-16 py-10 text-secondary-light bg-hover-neutral-200 text-hover-neutral-900 ${selectedCurrencyOption?.value === option.value ? "bg-primary-50 fw-semibold" : ""
                                                                    }`}
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    handleItemClick(option.raw);
                                                                    setCurrencySearch("");
                                                                }}
                                                            >
                                                                {option.label}
                                                                {selectedCurrencyOption?.value === option.value && (
                                                                    <i className="bi bi-check2 text-primary-600 ms-auto"></i>
                                                                )}
                                                            </a>
                                                        </li>
                                                    ))
                                                ) : (
                                                    <li className="text-center text-primary-600 small py-2">No Country found</li>
                                                )}
                                            </ul>
                                        </li>
                                    </ul>



                                </div>
                            </div>
                            {!state?.SET_USER?.referredBy ? (
                                <div className="col-md-6 mb-3">
                                    {/* <label className="form-label">Referral Code</label>
                                    <div className="form-control-plaintext fw-semibold">
                                        {state?.SET_USER?.referredBy}
                                    </div> */}
                                </div>
                            ) : (
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Referral Code</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={referredBy}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (value?.length <= 6) { // ✅ max 6 characters
                                                setreferredBy(value);
                                            }
                                        }}
                                        disabled={!!state?.SET_USER?.referredBy}
                                        placeholder="Enter your referral code"
                                    />
                                </div>
                            )}

                        </div>
                        <div className="d-flex flex-wrap align-items-center justify-content-end gap-2 mt-5">
                            <div className="d-flex gap-2">
                                <button
                                    type="reset"
                                    onClick={handleCancel}
                                    className="border btn-sm border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-6 radius-8"
                                >
                                    Back
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-primary-600 radius-8 d-inline-flex align-items-center px-40 py-6 radius-8 gap-2"
                                    onClick={handleSave}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default UserDetails;
